import React from 'react'
import { Box, Typography, Button, Card, CardContent, Alert } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'
import { CheckCircle as CheckCircleIcon, Home as HomeIcon, Login as LoginIcon } from '@mui/icons-material'

const LogoutConfirmation: React.FC = () => {
    const { t } = useTranslation()

    return (
        <Box sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 3,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
        }}>
            <Card sx={{
                maxWidth: 500,
                width: '100%',
                boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                borderRadius: 3
            }}>
                <CardContent sx={{ p: 4, textAlign: 'center' }}>
                    <CheckCircleIcon
                        sx={{
                            fontSize: 80,
                            color: 'success.main',
                            mb: 2
                        }}
                    />

                    <Typography variant="h4" component="h1" gutterBottom sx={{
                        fontWeight: 'bold',
                        background: 'linear-gradient(45deg, #667eea 30%, #764ba2 90%)',
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent'
                    }}>
                        {t('logout.successTitle', 'Erfolgreich abgemeldet')}
                    </Typography>

                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        {t('logout.successMessage', 'Sie wurden erfolgreich von Ihrem Konto abgemeldet. Alle Ihre Sitzungsdaten wurden sicher gelöscht.')}
                    </Typography>

                    <Alert severity="info" sx={{ mb: 3, textAlign: 'left' }}>
                        <Typography variant="body2">
                            {t('logout.securityNote', 'Aus Sicherheitsgründen empfehlen wir Ihnen, Ihren Browser zu schließen, wenn Sie an einem öffentlichen Computer arbeiten.')}
                        </Typography>
                    </Alert>

                    <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                        <Button
                            variant="contained"
                            startIcon={<HomeIcon />}
                            component={RouterLink}
                            to="/"
                            sx={{
                                minWidth: 140,
                                background: 'linear-gradient(45deg, #667eea 30%, #764ba2 90%)',
                                '&:hover': {
                                    background: 'linear-gradient(45deg, #5a6fd8 30%, #6a4190 90%)',
                                }
                            }}
                        >
                            {t('logout.backToHome', 'Zur Startseite')}
                        </Button>

                        <Button
                            variant="outlined"
                            startIcon={<LoginIcon />}
                            component={RouterLink}
                            to="/"
                            onClick={() => {
                                // Trigger login flow when user clicks login again
                                window.location.href = '/'
                            }}
                            sx={{ minWidth: 140 }}
                        >
                            {t('logout.loginAgain', 'Erneut anmelden')}
                        </Button>
                    </Box>

                    <Typography variant="caption" color="text.secondary" sx={{ mt: 3, display: 'block' }}>
                        {t('logout.thankYou', 'Vielen Dank für die Nutzung von Kavithai.de')}
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    )
}

export default LogoutConfirmation
